<template>
  <div style="min-height: 72px">
    <i v-if="loading" class="far fa-spinner-third fa-spin fa-1x"></i>
    <autocomplete-input
      v-else
      :path="`/qb/products-services?distributorId=${distributorId || null}`"
      :name="name"
      label="Name"
      v-model="model"
      :disabled="loading"
      :validate="validate"
      :searchable="false"
      :help-options="helpOptions"
      :limit="25"
      loadOnFocus
      isObject
      track-by="Id" />
  </div>
</template>

<script>
import { getOneProductsAndServices } from '@/api/qb';

export default {
  name: 'QuickBooksProductServiceAutocomplete',
  data() {
    return {
      loading: false,
      productService: null
    };
  },
  props: {
    value: {
      type: String
    },
    name: {
      type: String
    },
    distributorId: {
      type: String
    },
    validate: {
      type: String | Object
    },
    hasDisconnect: {
      type: Boolean,
      default: true
    },
    helpOptions: {
      type: Object | String
    }
  },
  computed: {
    model: {
      get() {
        return this.productService;
      },
      set(productService) {
        this.productService = productService;
        this.$emit('input', productService?.Id || null);
        this.$emit('change', productService);
      }
    }
  },
  async created() {
    try {
      this.loading = true;
      if (this.value) {
        this.productService = await getOneProductsAndServices(this.value, this.distributorId);
      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }
};
</script>
